import React from "react";
import { Box, Button, Chip, Paper, Typography } from "@material-ui/core";
import { BlockOutlined, CheckCircleOutline, ErrorOutline, HelpOutline, OpenInNew, VpnKeyOutlined } from "@material-ui/icons";
import { answerState, hasAnswer } from "./answerPresentation";
import useStyles from "./detailStyles";

const feedback = {
  correct: { label: "صحیح", icon: <CheckCircleOutline /> },
  incorrect: { label: "غلط", icon: <ErrorOutline /> },
  unanswered: { label: "بدون پاسخ", icon: <HelpOutline /> },
  excluded: { label: "حذف از آزمون", icon: <BlockOutlined /> },
  ungraded: { label: "ثبت شده", icon: <CheckCircleOutline /> },
};

export default function AnswerCard({ item, number }) {
  const classes = useStyles();
  const state = answerState(item);
  const input = String(item.userInput ?? "");
  const key = item.excludedFromScoring ? "" : item.scoringPolicy === "creditAll" ? "پاسخ صحیح برای همه"
    : item.rightAnswer || (item.acceptedAnswers || []).join(" یا ");
  return <Paper component="section" elevation={0} aria-label={`پاسخ ${number}`} className={`${classes.answerCard} ${classes[state]}`}>
    <Box className={classes.answerHeader}>
      <Box className={classes.number} aria-hidden="true">{number.toLocaleString("fa-IR")}</Box>
      <Typography component="h3" className={classes.answerTitle}>{item.title}</Typography>
      <Chip size="small" icon={feedback[state].icon} label={feedback[state].label} className={`${classes.badge} ${classes[`${state}Badge`]}`} />
    </Box>
    <Box className={classes.answerBody}>
      <Box className={classes.answerBox}>
        <Typography className={classes.answerLabel}>پاسخ کاربر</Typography>
        {/^https?:\/\//i.test(input) && <Button component="a" href={input} target="_blank" rel="noopener noreferrer" size="small" variant="outlined" color="primary" startIcon={<OpenInNew />} className={classes.fileLink}>نمایش پیوست</Button>}
        <Typography className={classes.answerText} color={hasAnswer(item) ? "textPrimary" : "textSecondary"}>{hasAnswer(item) ? input : "بدون پاسخ"}</Typography>
      </Box>
      {key && <Box className={`${classes.answerBox} ${classes.answerKey}`}>
        <Typography className={classes.answerLabel}><VpnKeyOutlined />پاسخ صحیح</Typography>
        <Typography className={classes.answerText}>{key}</Typography>
      </Box>}
    </Box>
    {item.excludedFromScoring && <Typography className={classes.answerNote}>این سوال در نتیجه آزمون محاسبه نشده است.</Typography>}
  </Paper>;
}
